import classNames from "classnames";
import {memo} from "react";

import {useMobileView} from "../../hooks/useMobileView";
import ButtonIconTooltip from "../ButtonIconTooltip";
import {
    Dropdown,
    DropdownItemLink,
    DropdownMenuItem,
    useDropdownMenuClickCallback,
    useThreeDotsTrigger
} from "../Dropdown";
import type {DropdownItemType} from "../Dropdown/types";
import {HStack} from "../ui/hstack";

type Item = DropdownItemType & {disabled?: boolean};

export interface Props {
    items: Item[];
    responsive?: boolean;
    className?: string;
}

const RightActions: React.FC<Props> = ({items, responsive = true, className}) => {
    const isMobile = useMobileView();
    const handleClickDropdown = useDropdownMenuClickCallback();

    const trigger = useThreeDotsTrigger();

    if (isMobile && responsive) {
        return (
            <Dropdown className="min-w-32" placement="bottom right" trigger={trigger}>
                {items.map(elem => (
                    <DropdownMenuItem key={elem.label} onPress={() => handleClickDropdown(elem)}>
                        <DropdownItemLink {...elem} />
                    </DropdownMenuItem>
                ))}
            </Dropdown>
        );
    }

    return (
        <HStack className={classNames("items-baseline justify-between", className)}>
            {items.map(elem => (
                <ButtonIconTooltip
                    key={elem.label}
                    icon={elem.Icon}
                    isDisabled={elem.disabled}
                    testID={elem.testID}
                    tooltip={elem.label}
                    onPress={elem.onPress}
                />
            ))}
        </HStack>
    );
};

export default memo(RightActions);
